import O1HD from "../../engines/gameEngine";
import data_control from "../../engines/libs/data_control";
import { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../../modes/normalMode/BundleResourceConfig";
import NormalGameManager from "../../modes/normalMode/manager/NormalGameManager";
import { getpawnShopObjMap, pawnShopFixGameObjExpendCount } from "../pawnShopGame/pawnShop/config/pawnShopConfig";
import { pawnShopBackpackObjI, pawnShopFixGameSelectDataI } from "../pawnShopGame/pawnShop/const/pawnShopConst";
import pawnShopFixGame from "./pawnShopFixGame";
import pawnShopFixSelectItem from "./pawnShopFixSelectItem";

const {ccclass, property} = cc._decorator;

enum fixGameSortType{
    obj,
    quality
}

@ccclass
export default class pawnShopFixGameSelectPage extends cc.Component {

    @property({type:cc.Enum(fixGameSortType),tooltip:"排序方式"})
    sortType:fixGameSortType = fixGameSortType.obj;

    @property({type:cc.Node,tooltip:"itemContent"})
    itemContent:cc.Node = null;

    @property({type:cc.Prefab,tooltip:"item预制体"})
    itemPrefab:cc.Prefab = null;

    @property({type:cc.RichText,displayName:"材料文本"})
    lbMaterial:cc.RichText = null;

    @property({type:cc.Label,displayName:"金钱文本"})
    lbCoin:cc.Label = null;

    @property({type:cc.Label,displayName:"修复按钮文本"})
    fixBtnLb:cc.Label = null;

    //当前选择的索引
    nowSelectData:pawnShopFixGameSelectDataI = null;
    //当前选择的节点
    nowSelectNode:cc.Node = null;

    //当前选的数据在背包中的索引
    nowDataInBackIndex:number = 0;

    start(){
        this.loadItems();
    }

    //初次加载
    async loadItems(){
        let ary = this.getRenderAry();
        for(let i = 0;i<ary.length;i++){
            await new Promise<void>(resolve=>{
                let item:cc.Node = cc.instantiate(this.itemPrefab);
                let data = ary[i];
                this.bindOneNodeData(item,data);
                this.itemContent.addChild(item);
                this.scheduleOnce(resolve);
                if(i == 0){
                    this.selectFun(item);
                }
            });
        }
    }

    //重新加载所有物体
    reLoadItems(){
        let ary = this.getRenderAry();
        this.itemContent.children.forEach((n:cc.Node,index:number)=>{
            this.bindOneNodeData(n,ary[index]);
        });
    }

    //一个节点绑定数据
    bindOneNodeData(node:cc.Node,data:pawnShopFixGameSelectDataI){
        if(!data){
            node.active = false;
            return;
        }
        node.active = true;
        let ns = node.getComponent(pawnShopFixSelectItem);
        ns.bindData(data,this.selectFun.bind(this));
    }

    //选择回调
    selectFun(node:cc.Node){
        let ns = node.getComponent(pawnShopFixSelectItem);
        //当前选择的数据
        this.nowSelectData = ns.backPackObj;
        this.setOneNodeSelelct(node);
        this.nowSelectNode = node;
    }

    //设置一个节点被选中
    setOneNodeSelelct(node:cc.Node){
        this.itemContent.children.forEach((n:cc.Node)=>{
            // 先将所有节点取消选择
            n.getComponent(pawnShopFixSelectItem).setSelect(false);
        });
        // 再将节点选择
        node.getComponent(pawnShopFixSelectItem).setSelect(true);

        //更新数据
        this.updateMaterialLb();
        this.updateCoinLabel();
        this.updateFixBtn();
    }

    //获取渲染数组
    getRenderAry(){
        let manager = NormalGameManager._instance.pawnShopManager;
        let ary:pawnShopFixGameSelectDataI[] = [];
        let backpack = manager.getData().backpack;
        // console.log(backpack);
        for(let key in backpack){
            let objs = backpack[key];
            let itemConfig = getpawnShopObjMap()[key];
            if(!itemConfig.canFix){
                continue;
            }
            for(let i =0;i<objs.length;i++){
                let obj = objs[i];
                let oo = {obj:obj,index:i};
                ary.push(oo);
            }
        }
        switch(this.sortType){
            case fixGameSortType.quality:{
                //按照品质排序
                ary.sort((a:pawnShopFixGameSelectDataI,b:pawnShopFixGameSelectDataI)=>{
                    let aObj = getpawnShopObjMap()[a.obj.id];
                    let bObj = getpawnShopObjMap()[b.obj.id];
                    return bObj.quality - aObj.quality;
                });
                break;
            }
        }
        for(let i =0;i<ary.length;i++){
            let obk = ary[i];
            obk.renderIndex = i;
        }
        return ary;
    }

    //更新按钮
    updateFixBtn(){
        if(this.nowSelectData.obj.fixCount >= this.nowSelectData.obj.canFixCount){
            this.fixBtnLb.string = "已修复";
            return;
        }
        this.fixBtnLb.string = "修复";
    }

    //更新材料文本
    updateMaterialLb(){
        let haveCount = NormalGameManager._instance.getOneGood(10000)?.num || 0;
        let color = haveCount >= pawnShopFixGameObjExpendCount ? "7cd351" : "FF0000"
        this.lbMaterial.string = `<color = #FFFFFF>需材料</c><color = #${color}>${haveCount}/${pawnShopFixGameObjExpendCount}</c><color = #FFFFFF>碎片修复一次</c>`;
    }

    getPrice(){
        let objConfig = getpawnShopObjMap()[this.nowSelectData.obj.id];
        let price = objConfig.price;
        let fixMultiple = this.nowSelectData.obj.fixCount * 1.5;
        let multiple = fixMultiple > 0 ?fixMultiple : 1;
        return price *= multiple;
    }

    //更新出售价格
    updateCoinLabel(){
        this.lbCoin.string = data_control.getNumberFormat(this.getPrice());
    }
    
    //点击修复
    async onBtnFix(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // 需要先判断是否可以进行修复 如果不能修复则跳过 如果可以修复则判断材料是否足够
        this.onFix();
        // 开始修复
    }

    async onFix(){
        if(!this.nowSelectData){
            O1HD.getModules().uiControlModule.showMessageBox("请选择修复的物品");
            return;
        }
        if(this.nowSelectData.obj.fixCount >= this.nowSelectData.obj.canFixCount){
            console.log("已完全修复");
            O1HD.getModules().uiControlModule.showMessageBox("已完全修复");
            return false;
        }
        let haveCount = NormalGameManager._instance.getOneGood(10000)?.num || 0;
        if(haveCount < pawnShopFixGameObjExpendCount){
            O1HD.getModules().uiControlModule.showMessageBox("材料不足");
            return false;
        }
        NormalGameManager._instance.onOutGoods(10000,pawnShopFixGameObjExpendCount);
        let url:string = "prefab/fixGame/pawnShopFixGame";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.pawnShopGameBundle,url);
        let pawnGame:cc.Node = cc.instantiate(prefab);
        let ps = pawnGame.getComponent(pawnShopFixGame);
        ps.bindData(this.nowSelectData,this);
        pawnGame.setParent(O1HD.Canvas());
        return true;
    }

    //点击出售
    onBtnSell(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // 出售当前选择的物品
        if(this.nowSelectData){
            this.sellObj();
        }else{
            O1HD.getModules().uiControlModule.showMessageBox("请选择出售的物品");
        }
    }
    
    sellObj(){
        let price = this.getPrice();
        O1HD.getServices().userSrv.setCoins(price,true,this.nowSelectNode);
        NormalGameManager._instance.pawnShopManager.removeOneObj(this.nowSelectData.obj.id,this.nowSelectData.index);
        let oldIndex:number = this.nowSelectData.renderIndex;
        this.reLoadItems();
        let ary = this.getRenderAry();
        let odata = ary[oldIndex];
        let tdata = ary[oldIndex - 1];
        if(odata){
            this.selectFun(this.itemContent.children[oldIndex]);
        }else if(tdata) {
            this.selectFun(this.itemContent.children[oldIndex - 1]);
        }else{
            this.nowSelectData = null;
            this.nowSelectNode = null;
        }
        
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.closeThis();
    }

}
